module.exports = __webpack_public_path__ + "static/media/experiencia.10120529.png";